export default "__VITE_ASSET__sdFXINfd__"